// // import { SplideSlide } from '@splidejs/react-splide'
// // import { useParams } from 'react-router'
// // import { Link } from 'react-router-dom'
// // import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider'
// // import SilderSponsersLogos from '../../../core/components/SilderSponsersLogos'

// // export default function SliderDiamondSponsorsLogos() {
// //   const { lng } = useParams()
// //   const { sponsorTypesState } = useSponsorTypesContext()

// //   if (sponsorTypesState.isLoading) {
// //     return (
// //       <div
// //         data-aos="fade-up"
// //         className="app-container"
// //       >
// //         <div className="h-[180px] animate-pulse bg-muted-400"></div>
// //       </div>
// //     )
// //   }
// //   if (sponsorTypesState.types.diamond?.have_sponsors)
// //     return (
// //       <SilderSponsersLogos
// //         type={'DIAMOND'}
// //         title={sponsorTypesState.types.diamond[`name_${lng}`]}
// //       >
// //         {sponsorTypesState.types.diamond?.sponsors.map((sponsor) => (
// //           <SplideSlide
// //             key={sponsor.id}
// //             className={`flex items-center justify-center`}
// //             title={sponsor[`name_${lng}`]}
// //           >
// //             <Link
// //               to={`/${lng}/sponsors/${sponsor.slug}`}
// //               className={`h-[120px] w-[120px] border-2 border-transparent p-4 hover:border-2 hover:border-muted-300 hover:bg-light`}
// //             >
// //               <img
// //                 src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.logo}`}
// //                 alt={sponsor[`name_${lng}`]}
// //                 className="h-full w-full object-contain"
// //               />
// //             </Link>
// //           </SplideSlide>
// //         ))}
// //       </SilderSponsersLogos>
// //     )
// // }











// import { SplideSlide } from '@splidejs/react-splide';
// import { useParams } from 'react-router';
// import { Link } from 'react-router-dom';
// import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider';
// import SilderSponsersLogos from '../../../core/components/SilderSponsersLogos';

// export default function SliderDiamondSponsorsLogos() {
//   const { lng } = useParams();
//   const { sponsorTypesState } = useSponsorTypesContext();

//   if (sponsorTypesState.isLoading) {
//     return (
//       <div data-aos="fade-up" className="app-container">
//         <div className="h-[180px] animate-pulse bg-muted-400"></div>
//       </div>
//     );
//   }

//   const types = sponsorTypesState.types;
//   const diamond = types?.diamond;

//   if (!diamond?.have_sponsors || !diamond.sponsors?.length) {
//     return null; // Ou tu peux afficher un message comme : <p>Pas de sponsors disponibles</p>
//   }

//   return (
//     <SilderSponsersLogos type="DIAMOND" title={diamond[`name_${lng}`]}>
//       {diamond.sponsors.map((sponsor) => (
//         <SplideSlide
//           key={sponsor.id}
//           className="flex items-center justify-center"
//           title={sponsor[`name_${lng}`]}
//         >
//           <Link
//             to={`/${lng}/sponsors/${sponsor.slug}`}
//             className="h-[120px] w-[120px] border-2 border-transparent p-4 hover:border-muted-300 hover:bg-light"
//           >
//             <img
//               src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.logo}`}
//               alt={sponsor[`name_${lng}`]}
//               className="h-full w-full object-contain"
//             />
//           </Link>
//         </SplideSlide>
//       ))}
//     </SilderSponsersLogos>
//   );
// }




import { SplideSlide } from '@splidejs/react-splide';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider';
import SilderSponsersLogos from '../../../core/components/SilderSponsersLogos';

export default function SliderDiamondSponsorsLogos() {
  const { lng } = useParams();
  const { sponsorTypesState } = useSponsorTypesContext();

  if (sponsorTypesState.isLoading) {
    return (
      <div data-aos="fade-up" className="app-container">
        <div className="h-[180px] animate-pulse bg-muted-400"></div>
      </div>
    );
  }

  const types = sponsorTypesState.types;
  const diamond = types?.diamond;

  if (!diamond?.have_sponsors || !diamond.sponsors?.length) {
    return null; // Ou tu peux afficher un message comme : <p>Pas de sponsors disponibles</p>
  }

  return (
    <SilderSponsersLogos type="DIAMOND" title={diamond[`name_${lng}`]}>
      {diamond.sponsors.map((sponsor) => (
        <SplideSlide
          key={sponsor.id}
          className="flex"
          title={sponsor[`name_${lng}`]}
        >
          <Link
            to={`/${lng}/sponsors/${sponsor.slug}`}
            className="h-[120px] w-[120px] border-2 border-transparent p-4 hover:border-muted-300 hover:bg-light"
          >
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.logo}`}
              alt={sponsor[`name_${lng}`]}
              className="h-full w-full object-contain"
            />
          </Link>
        </SplideSlide>
      ))}
    </SilderSponsersLogos>
  );
}


